'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertDismiss = require('./components/AlertDismiss.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlertDismiss).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/dismiss/index.js
// module id = 830
// module chunks = 0 3